import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioErrorFn = /* @__PURE__ */ createRecipe('radio-error', {}, [])

const radioErrorVariantMap = {}

const radioErrorVariantKeys = Object.keys(radioErrorVariantMap)

export const radioError = /* @__PURE__ */ Object.assign(memo(radioErrorFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioError',
  __getCompoundVariantCss__: radioErrorFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioErrorVariantKeys,
  variantMap: radioErrorVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioErrorVariantKeys)
  },
  getVariantProps: radioErrorFn.getVariantProps,
})